import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { renderFormattedText } from "Lib/text-utils";
import styles from "Styles/CompanySize.module.css";
import emoji from "Assets/emoji/emojis-group.png";

const MarketingStaffingInfoContent = ({ heading }) => {
  return (
    <InfoContentMotionWrapper>
      <h3 className={styles.heading}>{renderFormattedText(heading)}</h3>
      <div className={styles.decorativeElements}>
        <img
          src={emoji}
          alt="Emoji Group"
          style={{ maxWidth: "382px", width: "100%", marginTop: "50px" }}
        />
      </div>
    </InfoContentMotionWrapper>
  );
};

export default MarketingStaffingInfoContent;
